import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { FormikProps } from 'formik'
import { ApplicationConnection, ApplicationPermissionScope } from 'models'
import LabeledInputV2 from 'ui/components/form-components-v2/labeled-input-v2'
import { CONNECTED_BANNER_TEXT, CONNECTED_BANNER_TITLE, ConfigureFormValues } from '../applicationSetup.constants'
import { ApplicationProviderCopy } from '../applicationProviders'
import { ConfigureStepWrapper, ScopeChip } from '../applicationSetup.styles'
import { scopeLabel } from '../utils'

interface Props {
  copy: ApplicationProviderCopy
  connection: ApplicationConnection
  permissionScopes: ApplicationPermissionScope[]
  formik: FormikProps<ConfigureFormValues>
  busy: boolean
  noEditPermission: boolean
}

/* Step two: what the approval produced, read-only, and the one field still editable. */
const ConfigureStep: FC<Props> = ({ copy, connection, permissionScopes, formik, busy, noEditPermission }) => {
  const siteName = connection.provider_metadata?.site_name
  const siteUrl = connection.provider_metadata?.site_url

  return (
    <ConfigureStepWrapper>
      <Box className="success-banner">
        <Typography className="banner-title">{CONNECTED_BANNER_TITLE}</Typography>
        <Typography className="banner-text">{CONNECTED_BANNER_TEXT}</Typography>
      </Box>

      <Box className="connection-card">
        <Box className="card-block">
          <Typography className="card-label">{copy.siteLabel}</Typography>
          {!!siteName && <Typography className="card-value">{siteName}</Typography>}
          {!!siteUrl && <Typography className="card-address">{siteUrl}</Typography>}
        </Box>

        <Box className="card-block">
          <Typography className="card-label">{copy.permissionsLabel}</Typography>
          <Box className="scope-chips">
            {(connection.granted_scopes ?? []).map((code) => (
              <ScopeChip key={code} label={scopeLabel(permissionScopes, code)} size="small" />
            ))}
          </Box>
        </Box>
      </Box>

      <LabeledInputV2
        name="name"
        label="Name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        disabled={busy || noEditPermission}
        helperText={formik.errors.name}
      />
    </ConfigureStepWrapper>
  )
}

export default ConfigureStep
